import React from 'react'
import { Router } from 'react-router-dom'
import { history } from '../utils/history'

export const createFeatureContainer = (features: JSX.Element) => (
  <Router history={history}>
    {features}
  </Router>
)



// WEBPACK FOOTER //
// ./sampleProject/src/core/feature-loading/createFeatureContainer/index.tsx